var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1648",
    transform: "translate(-294 -2629)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(294 2629)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.596 2644.661a7.23 7.23 0 01-2.02.559 3.438 3.438 0 001.547-1.956 7.422 7.422 0 01-2.235.86 3.527 3.527 0 00-6.1 2.407 3.222 3.222 0 00.086.8 9.92 9.92 0 01-7.242-3.675 3.537 3.537 0 001.072 4.701 3.384 3.384 0 01-1.59-.43 3.561 3.561 0 002.815 3.5 3.868 3.868 0 01-1.59.064 3.539 3.539 0 003.288 2.45 7.1 7.1 0 01-5.223 1.465 10.014 10.014 0 0015.429-8.424 3.174 3.174 0 00-.021-.451 7 7 0 001.784-1.87z",
    fill: "#fff"
  }))));
}
export default SvgTwitterinline;